/* eslint-disable no-undef */
/* eslint-disable react/no-danger */
import React from 'react';
import { observer } from 'mobx-react';
import { userDetail } from 'Stores/userDetail';
import { Utils } from 'Utils/utils';

import seekerSampleCsvFile from '../../../assets/csv/Seeker_Sample_File.csv';
import { ReactComponent as LockIcon } from '../../../assets/svg/lock.svg';

const SeekerLeftComponent = observer(props => {
  const faqQuestionArr = [
    {
      question: 'What does Seeker do?',
      answer: `Seeker provides emails with confidence score for a list of first names, last names and domains. <a className="sample-csv" href=${seekerSampleCsvFile}>Click here</a > to download a sample file.`,
    },
    {
      question: 'How many files can I process?',
      answer:
        'You can process upto 10 files per day, per plan (including teams).',
    },
    {
      question: 'What is the upper limit for Seeker?',
      answer: 'Seeker can process upto 25,000 records per bulk task.',
    },
  ];

  const showPricingPopup = (e, key) => {
    if (e !== null) e.stopPropagation();
    Utils.upgradeNowClick('seeker');
  };

  return (
    <div className="leftContainer">
      <div className="page-title-text">Bulk Tools</div>
      <div className="contentContainer">
        <div className="topcontainer bulkTools">
          <div
            className={
              props.isGoogleTabSelected
                ? 'seekerBtnCont'
                : 'seekerBtnCont selected'
            }
            onClick={props.seekerAction}
          >
            {userDetail.featureFlags !== null &&
            userDetail.featureFlags.SEEKER !== undefined &&
            userDetail.featureFlags.SEEKER === false ? (
              <div className="seekerBtn blocked-wrap" data-name="seeker">
                Seeker
                <div className="lock-wrap">
                  <LockIcon className="dropdown-icon plus-icon lock-icon" />
                  <div className="phoneUpgrade filterLockUpgrade">
                    <div className="phoneUpgradeWrap">
                      <div className="up-text">
                        Seeker is not available in your current plan. Please
                        upgrade to a higher plan.
                      </div>
                      <div
                        onClick={e => showPricingPopup(e, 'Get Leads')}
                        className="locked-numbers-upgrade"
                      >
                        {Utils.getLockFilterBtnText()}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="seekerBtn" data-name="seeker">
                Seeker
                <i className="fa fa-angle-right dropdown-icon" />
              </div>
            )}
            <span className="seekerDesc">Get Emails for name and domain</span>
          </div>
          <div
            className={
              props.isGoogleTabSelected
                ? 'googleSheetCont selected'
                : 'googleSheetCont'
            }
            onClick={e => props.googleSheetBtnAction(true)}
          >
            {userDetail.featureFlags !== null &&
            userDetail.featureFlags.SEEKER !== undefined &&
            userDetail.featureFlags.SEEKER === false ? (
              <div
                className="googleSheetBtn blocked-wrap"
                data-name="googleSheet"
                title="Seeker - Google Sheets"
              >
                Seeker - Google Sheets
                <div className="lock-wrap">
                  <LockIcon className="dropdown-icon plus-icon lock-icon" />
                  <div className="phoneUpgrade filterLockUpgrade">
                    <div className="phoneUpgradeWrap">
                      <div className="up-text">
                        Seeker is not available in your current plan. Please
                        upgrade to a higher plan.
                      </div>
                      <div
                        onClick={e => showPricingPopup(e, 'Get Leads')}
                        className="locked-numbers-upgrade"
                      >
                        {Utils.getLockFilterBtnText()}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div
                className="googleSheetBtn"
                data-name="googleSheet"
                title="Seeker - Google Sheets"
              >
                Seeker - Google Sheets
                <i className="fa fa-angle-right dropdown-icon" />
              </div>
            )}
            <span className="seekerDesc">Find emails in Google Sheets</span>
          </div>
        </div>
        <div className="bottomContainer faq">
          <div className="faqCont">
            <div className="faqTitle h3Title">
              {/* <i className="fa fa-question-circle-o" /> */}
              FAQ
            </div>
            <ul className="questionCont">
              {faqQuestionArr &&
                faqQuestionArr.map((value, key) => {
                  return (
                    <li key={`seekerFaq${key}`} className="qstionAnswerCont">
                      <div className="question">{value.question}</div>
                      <div
                        className="answer"
                        dangerouslySetInnerHTML={{
                          __html: value.answer || '',
                        }}
                      />
                    </li>
                  );
                })}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
});

export { SeekerLeftComponent };
export default SeekerLeftComponent;
